<!-- LineChart.vue 子组件 -->
<template>
  <div ref="chart" style="width: 100%; height: 300px;" />
</template>

<script>
import * as echarts from "echarts"

export default {
  props: {
    xAxisData: {
      type: Array,
      default: () => []
    },
    legendData: {
      type: Array,
      default: () => []
    },
    seriesData: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      chart: null,
      resizeObserver: null
    }
  },
  watch: {
    seriesData: {
      handler() {
        this.setChart()
      },
      deep: true
    },
    xAxisData() {
      this.setChart()
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart()
      this.setupResizeObserver()
    })
  },
  beforeDestroy() {
    this.cleanupResources()
  },
  methods: {
    initChart() {
      if (!this.chart) {
        this.chart = echarts.init(this.$refs.chart)
        this.setChart()
      }
    },

    // 添加资源清理方法
    cleanupResources() {
      // 1. 销毁图表实例
      if (this.chart) {
        this.chart.dispose()
        this.chart = null
      }

      // 2. 移除窗口大小监听
      window.removeEventListener('resize', this.handleResize)

      // 3. 移除ResizeObserver监听
      if (this.resizeObserver) {
        this.resizeObserver.disconnect()
        this.resizeObserver = null
      }
    },

    // 使用ResizeObserver替代window.resize
    setupResizeObserver() {
      if (typeof ResizeObserver === 'function') {
        this.resizeObserver = new ResizeObserver(() => {
          this.handleResize()
        })
        this.resizeObserver.observe(this.$refs.chart)
      } else {
        // 浏览器不支持ResizeObserver时回退
        window.addEventListener('resize', this.handleResize)
      }
    },

    exportChart() {
      if (!this.chart) return Promise.resolve('')
      return new Promise((resolve) => {
        // 确保图表渲染完成
        setTimeout(() => {
          try {
            const dataURL = this.chart.getDataURL({
              type: 'png',
              pixelRatio: 2,
              backgroundColor: '#fff'
            })
            resolve(dataURL)
          } catch (e) {
            console.error('导出图表失败:', e)
            resolve('')
          }
        }, 300)
      })
    },

    setChart() {
      if (!this.chart) return

      const option = {
        title: { text: '' },
        tooltip: { trigger: 'axis' },
        legend: { data: this.legendData },
        xAxis: {
          type: 'category',
          data: this.xAxisData
        },
        yAxis: { type: 'value' },
        series: this.seriesData,
        grid: {
          left: '3%',
          right: '4%',
          bottom: '15%',
          containLabel: true
        },
        toolbox: {
          feature: {
            saveAsImage: { show: false }
          }
        }
      }

      this.chart.setOption(option, true) // true 表示不清除之前的配置
    },

    handleResize() {
      if (this.chart) {
        try {
          this.chart.resize()
        } catch (e) {
          console.warn('图表resize异常:', e)
        }
      }
    }
  }
}
</script>
